import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenNib, faCartShopping, faChartLine, faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons";
import Seo from "./Seo";
import ContactForm from "./ContactForm";

const Home: React.FC = () => {
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  const scrollToContact = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <main>
      <Seo
        title="HICO — Web Design & Development"
        description="HICO designs and builds high-performing websites and ecommerce stores — WordPress, Shopify, and custom builds for brands that want results."
        path="/"
      />
      <div>
        <section id="homepage">
          <div className="heroLayout">
            <h1 className="pageTitle">
              Design, development, and AI that deliver.
            </h1>
            <p className="heroSub heroSubLarge">
              From websites and online stores to smart AI integrations &mdash; thoughtfully designed, expertly built, and backed by people who truly know the technology.
            </p>
            <a className="btn-primary heroBtn" href="#contact" onClick={scrollToContact}>Start a project</a>
          </div>
          <ul>
       
            <li>
            <h4>Latest Launch</h4>
              <Link
                to="/work#15"
                rel="noopener noreferrer"
              >
                <img
                  alt="Forest Support reforestation website by American Forests"
                  width="500px"
                  src="/images/forestsupport.webp"
                />
              </Link>
              <span>Website for Forest Support<br/><em>reforestation programs by American Forests</em> </span>
            </li>
         
            <li>
            <h4>Previous Launch</h4>
              <Link
                to="/work#14"
                rel="noopener noreferrer"
              >
                <img
                  alt="ESA 2026 video game industry data resource website"
                  width="500px"
                  src="/images/theesa.webp"
                />
              </Link>
              <span>2026 Data Resource for the ESA<br/><em>the voice of the U.S. video game industry</em></span>
            </li>

            <li>
            <h4>Previous Launch</h4>
              <Link
                to="/work#16"
                rel="noopener noreferrer"
              >
                <img
                  alt="Voxboy portable podcast equipment Shopify store"
                  width="500px"
                  src="/images/voxboy.webp"
                />
              </Link>
              <span>Shopify Website for Voxboy<br/><em>Portable Podcast Equipment Company</em> </span>
            </li>
          </ul>

          <section className="valueProps" aria-label="What we do">
            <article className="valueCard">
              <FontAwesomeIcon icon={faPenNib} className="valueIcon" />
              <h2 className="valueTitle">Design &amp; Build</h2>
              <p>Sharp, fast, custom sites that turn first-time visitors into paying customers.</p>
              <Link className="cta" to="/work">See the work &rarr;</Link>
            </article>

            <article className="valueCard">
              <FontAwesomeIcon icon={faCartShopping} className="valueIcon" />
              <h2 className="valueTitle">Ecommerce That Sells</h2>
              <p>Shopify and custom stores built to grow revenue and run themselves.</p>
              <a className="cta" href="#contact" onClick={scrollToContact}>Start selling &rarr;</a>
            </article>

            <article className="valueCard">
              <FontAwesomeIcon icon={faChartLine} className="valueIcon" />
              <h2 className="valueTitle">Growth &amp; SEO</h2>
              <p>Performance, analytics, and SEO that get you found &mdash; and keep you climbing.</p>
              <a className="cta" href="#contact" onClick={scrollToContact}>Get a free audit &rarr;</a>
            </article>

            <article className="valueCard">
              <FontAwesomeIcon icon={faWandMagicSparkles} className="valueIcon" />
              <h2 className="valueTitle">AI, Done Right</h2>
              <p>Real AI integrations that automate work and sharpen results &mdash; implemented by people who know the technology end to end.</p>

              <a className="cta" href="#contact" onClick={scrollToContact}>Put AI to work &rarr;</a>
            </article>
          </section>

          <section className="homeContact" id="contact" aria-label="Get in touch">
            <div className="homeContactInner">
              <div className="homeContactCopy">
                <h2 className="valueTitle homeContactTitle">Let&rsquo;s build something great.</h2>
                <p>Tell us about your project and we&rsquo;ll get back to you within one business day. No pressure, no jargon &mdash; just a real conversation about what you need.</p>
              </div>
              <ContactForm />
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default Home;
